import { z } from 'zod';
import type { CloverResolvedEndpointSet } from '../../../types/ipg/clover/clover-resolved-endpoint-set.types';

function refineCloverHttpsEndpointUrl(value: string, context: z.RefinementCtx): void {
    let endpointUrl: URL;
    try {
        endpointUrl = new URL(value);
    } catch {
        return;
    }
    if (endpointUrl.protocol !== 'https:') {
        context.addIssue({
            code: 'custom',
            message: 'Clover endpoint URLs must use HTTPS',
        });
    }
    if (endpointUrl.username.length > 0 || endpointUrl.password.length > 0) {
        context.addIssue({
            code: 'custom',
            message: 'Clover endpoint URLs must not contain credentials',
        });
    }
    if (endpointUrl.search.length > 0) {
        context.addIssue({
            code: 'custom',
            message: 'Clover endpoint URLs must not contain a query',
        });
    }
    if (endpointUrl.hash.length > 0) {
        context.addIssue({
            code: 'custom',
            message: 'Clover endpoint URLs must not contain a fragment',
        });
    }
}

export const CloverHttpsEndpointUrlSchema: z.ZodType<string> = z
    .url()
    .superRefine(refineCloverHttpsEndpointUrl);

export const CloverResolvedEndpointSetSchema: z.ZodType<CloverResolvedEndpointSet> = z
    .object({
        platformApiBaseUrl: CloverHttpsEndpointUrlSchema,
        ecommerceApiBaseUrl: CloverHttpsEndpointUrlSchema,
        browserTokenizationBaseUrl: CloverHttpsEndpointUrlSchema,
        cloudPayDisplayBaseUrl: CloverHttpsEndpointUrlSchema,
    })
    .strict();
